import { PUBLIC_INQUIRY_PATH } from '../marketing/marketingNav'

export const EARLY_BIRD_LABEL = '얼리버드'
export const EARLY_BIRD_NOTE = 'ENTERPRISE는 정가 39,000원에서 얼리버드 월 29,000원으로 제공합니다.'

/** 1개월 결제 기준 금액(원). */
export const TIER_MONTHLY_SUPPLY_KRW = {
  basic: 9900,
  enterprise: 29000,
}

/**
 * 1개월 정가(원). 결제/BE 빌링 시드와 운영 정책을 함께 맞춰야 합니다.
 */
export const TIER_LIST_MONTHLY_KRW = {
  basic: 9900,
  enterprise: 39000,
}

/** 1개월: 월 정가 대비 혜택가 할인율(%), 반올림. */
export function listToSaleDiscountPercentRounded(listMonthlyKrw, saleMonthlyKrw) {
  const list = Number(listMonthlyKrw)
  const sale = Number(saleMonthlyKrw)
  if (!Number.isFinite(list) || list <= 0 || !Number.isFinite(sale) || sale >= list) return 0
  return Math.round((1 - sale / list) * 100)
}

/**
 * 마케팅 요금표(/pricing) 카드.
 */
export const marketingPlans = [
  {
    id: 'basic',
    name: 'BASIC',
    badge: '기본',
    listMonthlyKrw: TIER_LIST_MONTHLY_KRW.basic,
    saleMonthlyKrw: TIER_MONTHLY_SUPPLY_KRW.basic,
    price: `${new Intl.NumberFormat('ko-KR').format(TIER_MONTHLY_SUPPLY_KRW.basic)}원`,
    period: '1인 · 1개월 결제 기준',
    desc: '월간 쿼터로 분석·리포트·보험금청구를 이용하는 기본 플랜입니다.',
    cta: { label: 'BASIC 가입', to: '/checkout?product=basic-1m', primary: true },
    // secondaryCta: { label: '문의하기', to: PUBLIC_INQUIRY_PATH },
    featured: false,
  },
  {
    id: 'enterprise',
    name: 'ENTERPRISE',
    badge: '확장',
    listMonthlyKrw: TIER_LIST_MONTHLY_KRW.enterprise,
    saleMonthlyKrw: TIER_MONTHLY_SUPPLY_KRW.enterprise,
    price: `${new Intl.NumberFormat('ko-KR').format(TIER_MONTHLY_SUPPLY_KRW.enterprise)}원`,
    period: '1인 · 1개월 결제 기준',
    desc: '월간 포함량을 넉넉하게 제공하는 확장 플랜입니다.',
    cta: { label: 'ENTERPRISE 가입', to: '/checkout?product=enterprise-1m', primary: true },
    // secondaryCta: { label: '문의하기', to: PUBLIC_INQUIRY_PATH },
    featured: true,
  },
  {
    id: 'organization-contract',
    name: '단체계약',
    badge: '조직 계약',
    listMonthlyKrw: null,
    saleMonthlyKrw: null,
    price: '별도 견적',
    period: 'GA·조직 계약 기준',
    desc: '좌석 수, 조직 구조, 운영 범위에 맞춰 계약 조건과 할인율을 별도로 협의합니다.',
    cta: { label: '단체계약 상담', to: PUBLIC_INQUIRY_PATH, primary: false },
    featured: false,
    contractOnly: true,
  },
]

export const organizationContractPlan = marketingPlans.find((plan) => plan.id === 'organization-contract')

const tierMeta = [
  {
    id: 'basic',
    codePrefix: 'SUB_BASIC',
    name: 'BASIC',
    checkoutTitle: '베이직',
    checkoutBadge: '기본',
    monthly: TIER_MONTHLY_SUPPLY_KRW.basic,
    listMonthly: TIER_LIST_MONTHLY_KRW.basic,
  },
  {
    id: 'enterprise',
    codePrefix: 'SUB_ENTERPRISE',
    name: 'ENTERPRISE',
    checkoutTitle: '엔터프라이즈',
    checkoutBadge: '확장',
    monthly: TIER_MONTHLY_SUPPLY_KRW.enterprise,
    listMonthly: TIER_LIST_MONTHLY_KRW.enterprise,
  },
]

/**
 * 공개 결제(/checkout) 상품 — 티어별 1개월 상품.
 */
export const checkoutProducts = tierMeta.map((t) => {
  const monthlyDisc = listToSaleDiscountPercentRounded(t.listMonthly, t.monthly)
  return {
    id: `${t.id}-1m`,
    code: `${t.codePrefix}_1M`,
    tierId: t.id,
    tierName: t.name,
    name: `${t.checkoutTitle} · 1개월`,
    summary: monthlyDisc > 0 ? `1인 기준 · 1개월 이용 · ${monthlyDisc}% 할인` : '1인 기준 · 1개월 이용',
    periodLabel: '1개월',
    supplyPriceKrw: t.monthly,
    listPriceKrw: t.listMonthly,
    discountPercent: monthlyDisc,
  }
})

/** 결제 화면: 요금 안내 카드 순서와 동일하게 티어별로 묶음 */
export const checkoutTierGroups = tierMeta.map((t) => ({
  id: t.id,
  title: t.checkoutTitle,
  badge: t.checkoutBadge,
  products: checkoutProducts.filter((p) => p.tierId === t.id),
}))

/**
 * 공개 체크아웃 상품 → BE 견적/주문과 동일한 planCode·period.
 * @param {{ tierName?: string } | null | undefined} product
 */
export function billingParamsFromCheckoutProduct(product) {
  if (!product || typeof product.tierName !== 'string') {
    return { planCode: 'BASIC', period: 'MONTH' }
  }
  const planCode = String(product.tierName).toUpperCase()
  return { planCode, period: 'MONTH' }
}

/** 공개 요금 비교표 — 행: basic / enterprise */
export const planComparisonSections = [
  {
    title: '영업지원',
    rows: [
      { label: '모바일 명함', basic: '제공', enterprise: '제공' },
      { label: '개인 홈페이지', basic: '제공', enterprise: '제공' },
      { label: '홍보용 랜딩페이지', basic: '제공', enterprise: '제공' },
      { label: '조직배너·조직 홈페이지', basic: '조직 계약 전용', enterprise: '조직 계약 전용' },
    ],
  },
  {
    title: '고객지원',
    rows: [
      { label: '고객관리', basic: '제공', enterprise: '제공' },
      { label: '보험계약·만기 관리', basic: '제공', enterprise: '제공' },
      { label: '보험금청구', basic: '월 2건 / 최대 30장', enterprise: '월 30건 / 최대 300장' },
      { label: '보험금청구 결과 알림', basic: '청구 건에 포함', enterprise: '청구 건에 포함' },
    ],
  },
  {
    title: '분석지원',
    rows: [
      { label: '진료정보분석', basic: '월 5건', enterprise: '월 50건' },
      { label: '숨은보험금찾기', basic: '월 5건', enterprise: '월 50건' },
      { label: '설문/통합 리포트 AI', basic: '월 5건', enterprise: '월 50건' },
      { label: '사진 배경 제거', basic: '월 3건', enterprise: '월 10건' },
      { label: '진단시뮬레이션', basic: '월 10건', enterprise: '제공' },
      { label: '3종 확인서', basic: '일부 GA', enterprise: '일부 GA' },
    ],
  },
  {
    title: '업무지원',
    rows: [
      { label: '오늘의 업무브리핑 알림', basic: '기본 알림', enterprise: '기본 알림 + 확장 알림' },
      { label: '보험약관·표준서식 요약', basic: '제공', enterprise: '제공' },
      { label: '교육/자료실', basic: '제공', enterprise: '제공' },
    ],
  },
]

/** 공급가에 대한 부가세율(표시용). 청구서·세금계산서는 별도 규정에 따릅니다. */
export const checkoutVatRate = 0.1

export function formatKrw(n) {
  const v = Number(n)
  if (!Number.isFinite(v)) return '-'
  return `${new Intl.NumberFormat('ko-KR').format(Math.round(v))}원`
}

export function computeVatAndTotal(supplyPriceKrw, vatRate = checkoutVatRate) {
  const supply = Number(supplyPriceKrw) || 0
  const vat = Math.round(supply * vatRate)
  return { supply, vat, total: supply + vat }
}
